import Tab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import React, { memo } from 'react';
import Divider from '@mui/material/Divider';
import { grey } from '@mui/material/colors';
import { SxProps, Theme, useTheme } from '@mui/system';

export type TabsData = {
  disabled?: boolean;
  tabContent: React.ReactNode;
  tabTitle: React.ReactElement | string;
  tabValue: string;
};

export type HorizontalTabsProps = {
  'data-testid'?: string;
  onTabChange: (tab: string) => void;
  sx?: SxProps<Theme>;
  tabHeaderActions?: React.ReactNode;
  tabsData: TabsData[];
  value: string;
};

const HorizontalTabs = (props: HorizontalTabsProps) => {
  const theme = useTheme();

  return (
    <Box data-testid={props['data-testid']} sx={props?.sx}>
      <Stack className="tabHeaderWrapper" flexDirection={'row'}>
        <Stack className="tabHeader" flexDirection={'row'}>
          {props.tabsData?.map?.((t, i) => {
            const selected = t.tabValue === props.value;
            return (
              <Stack
                className={`tab ${selected ? 'selectedTab' : ''}`}
                key={i}
                onClick={() =>
                  t.disabled ? undefined : props.onTabChange(t.tabValue)
                }
                sx={{
                  alignItems: 'center',
                  borderBottom: `3px solid ${
                    selected ? theme.palette.primary.main : 'transparent'
                  }`,
                  height: `36px`,
                  justifyContent: 'center',
                  minWidth: 150,
                }}
              >
                <Stack
                  component={Tab}
                  disabled={t.disabled}
                  label={t.tabTitle}
                  sx={{
                    alignSelf: 'self-center',
                    color: selected ? theme.palette.primary.main : grey[600],
                    fontSize: `14px`,
                    fontWeight: 600,
                    lineHeight: `36px`,
                    opacity: 1,
                    pb: 0,
                    pt: 0,
                    textTransform: 'none',
                  }}
                >
                  {t.tabTitle}
                </Stack>
              </Stack>
            );
          })}
        </Stack>
        {props?.tabHeaderActions}
      </Stack>
      <Divider
        className="divider horizontalDivider"
        sx={{ height: 'inherit' }}
      />
      <Stack className="tabContent" pt={2}>
        {
          props.tabsData?.find((tab) => tab.tabValue === props?.value)
            ?.tabContent
        }
      </Stack>
    </Box>
  );
};

export default memo(HorizontalTabs);
